<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
// type oneToNine = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
// type zeroToNine = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9

// type YYYY = `19${zeroToNine}${zeroToNine}` | `20${zeroToNine}${zeroToNine}`
// type MM = `0${oneToNine}` | `1${0 | 1 | 2}`
// type DD = `${0}${oneToNine}` | `${1 | 2}${zeroToNine}` | `3${0 | 1}`

import type { RawDateString } from '~/types/shopware'

// Detailed type definition (commented for reference):
// type oneToNine = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
// type zeroToNine = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
// type YYYY = `19${zeroToNine}${zeroToNine}` | `20${zeroToNine}${zeroToNine}`
// type MM = `0${oneToNine}` | `1${0 | 1 | 2}`
// type DD = `${0}${oneToNine}` | `${1 | 2}${zeroToNine}` | `3${0 | 1}`
// export type RawDateString = `${YYYY}-${MM}-${DD}` - too strict for real-world usage

const props = defineProps<{
  name: string
  required: boolean
  before?: RawDateString | Date
  after?: RawDateString | Date
  label?: string
  value?: RawDateString
  validation?: string
  validationMessages?: {
    [key: string]: string
  }
  id?: string
}>()

const attrs = useAttrs()
const hasValidation = ref(!!(props.required || props.validation))
const isFocused = ref(false)
const isFilled = ref(!!props.value)

const validationString = computed(() => {
  const validationString = props.validation ?? ''
  const v = validationString.split('|')
  if (props.required) {
    v.push('required')
  }

  if (props.before) {
    v.push(`date_before:${props.before}`)
  }

  if (props.after) {
    v.push(`date_after:${props.after}`)
  }

  return v.filter(Boolean).join('|')
})

const handleFocus = (f: boolean) => {
  isFocused.value = f
}

const classes: Ref<string> = ref('')
watch(
  [isFilled, isFocused, hasValidation, () => attrs.class],
  () => {
    classes.value = [
      isFilled.value ? 'is-filled' : '',
      isFocused.value ? 'is-focused' : '',
      hasValidation.value ? 'has-validation' : '',
      attrs.class ?? '',
    ]
      .filter(Boolean)
      .join(' ')
  },
  { immediate: true },
)
</script>

<template>
<FormKitLazyProvider config-file="true">

  <FormKit
    :id="id"
    type="date"
    :name="name"
    :label="label ?? ''"
    :value="value ?? ''"
    :validation="validationString ?? ''"
    :validation-message="validationMessages ?? {}"
    :classes="{
      outer: `custom-date-input ${classes}`,
    }"
    @focus="() => handleFocus(true)"
    @blur="() => handleFocus(false)"
    @input="(value: unknown) => (isFilled = value !== '')"
  />

</FormKitLazyProvider>
</template>

<style lang="scss" scoped></style>
